
import { defineComponent, computed } from 'vue';
import {
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonLabel,
  IonIcon,
  IonPage,
  IonRouterOutlet,
} from '@ionic/vue';
import { tvOutline, tv, copy, copyOutline } from 'ionicons/icons';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'TabsPage',
  components: {
    IonLabel,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonPage,
    IonRouterOutlet,
  },
  setup: () => {
    const currentRoute = computed(() => {
      const router = useRouter();
      console.log(router.options.routes);
      return router.currentRoute.value.path;
    });
    return {
      tvOutline,
      tv,
      copy,
      copyOutline,
      currentRoute,
    };
  },
});
